/* 🤖 this file was generated by svg-to-ts*/
export const icoStar: {
  name: 'star';
  data: string;
} = {
  name: 'star',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.279 9H4l-.114.006c-.853.09-1.214 1.186-.528 1.76l4.269 3.579-1.586 5.372-.026.105c-.165.868.834 1.529 1.576.984L12 17.573l4.41 3.233.091.06c.744.438 1.688-.237 1.47-1.108l-1.353-5.414 4.047-3.597.08-.079C21.314 10.044 20.881 9 20 9h-5.28l-1.771-5.316c-.304-.912-1.594-.912-1.898 0L9.28 9zM12 7.161l1.051 3.155.043.108A1 1 0 0014 11h3.369l-2.533 2.253-.087.087a1 1 0 00-.219.902l.828 3.313-2.767-2.028-.109-.07a1 1 0 00-1.073.07l-2.61 1.913.933-3.157.029-.128a1 1 0 00-.346-.921L6.75 11H10a1 1 0 00.949-.684L12 7.161z" fill="#909090"/></svg>`
};
